import { usePermissions } from '@refinedev/core';
import { Result, Spin } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Page gate: `sms_messaging_list` is required (the API enforces it again, plus the root tenant). */
export const SaSmsGuard: React.FC<{ children: (canEdit: boolean) => ReactNode }> = ({
    children,
}) => {
    const { t } = useTranslation(['sa-sms']);
    const { data: permissions, isLoading } = usePermissions<string[]>();
    if (isLoading) return <Spin style={{ display: 'block', margin: '64px auto' }} />;
    if (!permissions?.includes('sms_messaging_list')) {
        return <Result status="403" title={t('forbidden')} />;
    }
    return <>{children(permissions.includes('sms_messaging_edit'))}</>;
};
